// extracted by mini-css-extract-plugin
export default {"root":"li_cq","chevronRightIcon":"b0Vrv"};